const Title = ({ text }) => {
  const base =
    'text-headingCardsMobile md:text-headingCardsDesktop text-olive text-center md:text-left font-ttDrugsTrial uppercase'

  return <span className={base}>{text}</span>
}

export default Title
